import { Boolean, Literal, Null, Record, Static, String } from 'runtypes';

export const AlarmRunType = Record({
	alarmTimestamp: String,
	id: String,
	overriddenAlarmTimestamp: Boolean,
	timestamp: String,
	title: String,
	type: Literal('appointment')
		.Or(Literal('task'))
		.Or(Literal('taskOwner'))
		.Or(Literal('taskOwnerAlways'))
		.Or(Literal('activity')),
});

export type Alarm = Static<typeof AlarmRunType>;

export const AlarmWithUserAlarmRunType = Record({
	alarmTimestamp: String,
	id: String,
	overriddenAlarmTimestamp: Boolean,
	timestamp: String,
	title: String,
	type: Literal('appointment')
		.Or(Literal('task'))
		.Or(Literal('taskOwner'))
		.Or(Literal('taskOwnerAlways'))
		.Or(Literal('activity')),
	userAlarmTimestamp: String.Or(Null),
});

export type AlarmWithUserAlarm = Static<typeof AlarmWithUserAlarmRunType>;
